import { FC } from "react";

import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SubmitButton,
} from "@websential/cosmic-v20";

export interface IPDFFilesToolbar {
	onResetClicked: () => void;
	isSubmitting: boolean;
}
export const PDFFilesToolbar: FC<IPDFFilesToolbar> = ({
	onResetClicked,
	isSubmitting = false,
}) => {
	return (
		<Toolbar>
			<>
				{/* <div style={{ display: "contents" }}>
					<div style={{ margin: "1rem 0rem" }}>
						<SubmitButton
							label="Submit"
							testId="submit-button"
							loading={isSubmitting}
							icon={<PlaylistAddCheckOutlinedIcon />}
						/>
					</div>
					<ResetButton testId="reset-button" onClickHandler={onResetClicked} />
				</div>
				<div style={{ flexGrow: 1 }} />
				<div>
					<></>
				</div> */}
				<EnhancedButtonPrimeReact
					label="Submit"
					loading={isSubmitting}
					type="submit"
					// icon="pi pi-check"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-plus"
					label="Reset"
					raised
					onClickHandler={onResetClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</>
		</Toolbar>
	);
};
